import { ReactNode } from "react";
import { Card, Col, Divider, Row, Typography } from "antd";
import { useHistory } from "react-router-dom";
import styles from "./StatsItem.module.scss";
import { StatsItemSkeleton } from "../stats-item-skeleton";

export interface StatsItemProps {
  loading?: boolean;
  icon: ReactNode;
  link: { title: string; toPath: string };
  status: string;
  primaryNumber: number;
  secondaryNumber: number;
  department: string;
}

export const StatsItem = (props: StatsItemProps) => {
  const {
    loading = false,
    icon,
    link,
    primaryNumber,
    secondaryNumber,
    department,
  } = props;
  const history = useHistory();

  if (loading) {
    return <StatsItemSkeleton />;
  }

  return (
    <Card className={styles.card} onClick={() => history.push(link.toPath)}>
      <div className={styles.container}>
        <div className={styles.title}>
          {icon}
          <Row>
            <Col span={18} className={styles.primaryLabel}>
              {department}
            </Col>
            <Col span={6}>
              <Typography.Text
                className={styles.primaryNumber}
                ellipsis={{ tooltip: primaryNumber }}
              >
                {primaryNumber}
              </Typography.Text>
            </Col>
          </Row>
        </div>
        <div>
          <Divider className={styles.divider} />
          <Row className={styles.bottom}>
            <Col span={18} className={styles.secondaryLabel}>
              Các yêu cầu cần duyệt
            </Col>
            <Col span={6}>
              <Typography.Text
                className={styles.secondaryNumber}
                ellipsis={{ tooltip: secondaryNumber }}
              >
                {secondaryNumber}
              </Typography.Text>
            </Col>
          </Row>
        </div>
      </div>
    </Card>
  );
};
